import { Component, OnInit,HostListener } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import * as bath from 'thai-baht-text';
//https://stackblitz.com/edit/ngx-barcode-demo?file=app%2Fapp.component.html
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-print-invoice',
  templateUrl: './print-invoice.component.html',
  styleUrls: ['./print-invoice.component.scss']
})
export class PrintInvoiceComponent implements OnInit {
  @HostListener('window:afterprint', ['$event'])
  public afterPrintHandler(event) {
    window.close();
    window.stop();
    console.log('Printing finished or canceled.ๅๅๅ');
  }
  detail = [];
  invoice_id = '';
  customer_id = '';
  customer_name = '';
  place_description = '';
  place_address = '';
  place_id = '';
  fee_id = '';
  // fee_description='';
  // fee_count='';
  fee_type_unit = '';
  // fee_type_price='';
  due_datetime = '';
  create_datetime = '';
  price = '';
  total_price = '';
  discount = '';
  user = '';
  barcode = '';
  total_price_bath = '';
  tambon = '';
  amphur = '';
  province = '';
  postcode = '';
  // service_price='';
  // fee_price='';
  total = '';
  total_baht = '';
  fee_type_description = '';
  length = 0;
  now = '';
  background = '#ffffff'
  isLoading = true;
  base64_img_muni = null;
  img_src = null;
  muni_thname = null;
  muni_amphurth = null;
  muni_tambonth = null;
  muni_thprovince = null;
  muni_postcode = null;
  muni_contact_phone = null;
  qr_code = null;
  municipality = null;
  lineqr_code = null;
  base64_img_muni_lineqr = null;
  status_pay = null;
  date_filter = null;
  day = null;
  month = null;
  year = null;
  report = null;
  users = null;
  constructor(private route: ActivatedRoute, router: Router, private service: MyserviceService, private sanitizer: DomSanitizer) { };

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      //debugger
      this.invoice_id = params['invoice_id'];
      this.place_id = params['place_id'];
      this.status_pay = params['status_pay'],
        this.date_filter = params['date_filter'];
      this.day = params['day'];
      this.month = params['month'];
      this.year = params['year'];
      this.report = params['report'];
    });

    this.refresh();

    const get_Storage_invoice_multi = sessionStorage.getItem('municipality')
    this.users = JSON.parse(sessionStorage.getItem('user'))

    this.municipality = JSON.parse(sessionStorage.getItem('municipality'))
    this.qr_code = `http://203.150.210.93:5002/${this.municipality.qr_code}`

    this.base64_img_muni = `data:image/png;base64,${JSON.parse(get_Storage_invoice_multi).icon_img}`
    this.img_src = this.sanitizer.bypassSecurityTrustUrl(this.base64_img_muni);
    const thname_muni = JSON.parse(get_Storage_invoice_multi).th_name;
    this.muni_thname = this.sanitizer.bypassSecurityTrustHtml(thname_muni);
    const thamphurth_muni = JSON.parse(get_Storage_invoice_multi).th_amphur;
    this.muni_amphurth = this.sanitizer.bypassSecurityTrustHtml(thamphurth_muni);
    const tambonth_muni = JSON.parse(get_Storage_invoice_multi).th_tambon;
    this.muni_tambonth = this.sanitizer.bypassSecurityTrustHtml(tambonth_muni);
    const provinceth_muni = JSON.parse(get_Storage_invoice_multi).th_province;
    this.muni_thprovince = this.sanitizer.bypassSecurityTrustHtml(provinceth_muni);
    const postcode_muni = JSON.parse(get_Storage_invoice_multi).postcode;
    this.muni_postcode = this.sanitizer.bypassSecurityTrustHtml(postcode_muni);
    const phone_muni = JSON.parse(get_Storage_invoice_multi).contact_phone;
    this.muni_contact_phone = this.sanitizer.bypassSecurityTrustHtml(phone_muni);
    this.base64_img_muni_lineqr = `http://203.150.210.93:5002/${JSON.parse(get_Storage_invoice_multi).line_qr_code}`
    this.lineqr_code = this.sanitizer.bypassSecurityTrustUrl(this.base64_img_muni_lineqr);
  }

  refresh() {
    var data;
    if (this.invoice_id != undefined) {
      data = { invoice_id: this.invoice_id, status_pay: this.status_pay, topic: 'inv', date_filter: JSON.parse(this.date_filter), report: this.report, day: this.day, month: this.month, year: this.year }
    }
    if (this.place_id != undefined) {
      data = { place_id: this.place_id, status_pay: this.status_pay, topic: 'inv', date_filter: JSON.parse(this.date_filter), report: this.report, day: this.day, month: this.month, year: this.year }
    }

    this.isLoading = true;
    this.service.postData(data, "invoice/get-invoice-detail").then((result: any) => {
      //debugger
      this.isLoading = false;
      console.log(result.data);
      if (!result.code) {
        if (result.data.length > 0) {
          this.length = Number(result.data.length);

          this.customer_id = result.data[0].customer_id;
          this.customer_name = result.data[0].customer_name;
          this.place_id = result.data[0].place_id;
          this.place_address = result.data[0].place_address;
          this.tambon = result.data[0].tambon_th;
          this.amphur = result.data[0].amphur_th;
          this.province = result.data[0].province_th;
          this.postcode = result.data[0].postcode;
          this.place_description = result.data[0].place_description;
          this.fee_id = result.data[0].fee_id;
          this.fee_type_description = result.data[0].fee_type_description;
          this.fee_type_unit = result.data[0].fee_type_unit;


          // Loop for detail in table
          var temp = 0
          for (let i = 0; i < result.data.length; i++) {
            var invoice_id = result.data[i].invoice_id;
            var fee_type_price = Number(result.data[i].fee_type_price).toFixed(2);
            var fee_count = result.data[i].fee_count;
            var fee_price = Number(result.data[i].fee_price).toFixed(2);
            var service_price = Number(result.data[i].service_price).toFixed(2);
            var sum = (Number(result.data[i].fee_price) + Number(result.data[i].service_price)).toFixed(2)
            temp += Number(sum)
            var total = sum
            var fee_description;
            var xy = 0;
            xy = parseInt(moment(result.data[i].due_date).format('YYYY'));

            if (xy < 2500) {
              xy = xy + 543;
            }

            var due_datetime = moment(result.data[i].due_date).format("DD/MM/") + xy;
            switch (moment(result.data[i].due_date).format("MM")) {
              case '01':
                fee_description = result.data[i].fee_description + ' (มกราคม)';
                break
              case '02':
                fee_description = result.data[i].fee_description + ' (กุมภาพันธ์)';
                break
              case '03':
                fee_description = result.data[i].fee_description + ' (มีนาคม)';
                break
              case '04':
                fee_description = result.data[i].fee_description + ' (เมษายน)';
                break
              case '05':
                fee_description = result.data[i].fee_description + ' (พฤษภาคม)';
                break
              case '06':
                fee_description = result.data[i].fee_description + ' (มิถุนายน)';
                break
              case '07':
                fee_description = result.data[i].fee_description + ' (กรกฏาคม)';
                break
              case '08':
                fee_description = result.data[i].fee_description + ' (สิงหาคม)';
                break
              case '09':
                fee_description = result.data[i].fee_description + ' (กันยายน)';
                break
              case '10':
                fee_description = result.data[i].fee_description + ' (ตุลาคม)';
                break
              case '11':
                fee_description = result.data[i].fee_description + ' (พฤศจิกายน)';
                break
              case '12':
                fee_description = result.data[i].fee_description + ' (ธันวาคม)';
                break
            }

            this.detail.push({
              invoice_id: invoice_id,
              fee_description: fee_description,
              fee_type_price: fee_type_price,
              fee_count: fee_count,
              fee_price: fee_price,
              service_price: service_price,
              total: total,
              due_datetime: due_datetime
            })
          }

          this.total_baht = bath(temp);
          this.total = `${temp.toFixed(2)}`

          var xy = 0;
          xy = parseInt(moment().format('YYYY'));

          if (xy < 2500) {
            xy = xy + 543;
          }

          this.now = moment().format("DD/MM/") + xy;

          xy = 0;
          xy = parseInt(moment(result.data[0].create_datetime).format('YYYY'));

          if (xy < 2500) {
            xy = xy + 543;
          }
          this.create_datetime = moment(result.data[0].create_datetime).format("DD/MM/YYYY HH:mm").replace(moment(result.data[0].create_datetime).format('YYYY'), xy.toString());
          this.invoice_id = result.data[0].invoice_id;
          this.price = result.data[0].total_price.toFixed(2);
          this.total_price = result.data[0].total_price;
          this.barcode = this.customer_id + ' ' + this.place_id;
          this.total_price_bath = bath(this.price);
          console.log(this.total_price_bath)
          this.service.postData({ user_id: result.data[0].user_id }, "user-location/get-user-detail").then((result2: any) => {
            if (!result2.code) {
              if (result2.data.length > 0) {
                this.user = result2.data[0].user_name;
                setTimeout(() => {
                  window.print();
                }, 1000);
              } else {
                this.user = result2.data[0].user_id;
                setTimeout(() => {
                  window.print();
                }, 1000);
              }
            }
            else {
              Swal.fire({
                title: result.message,
                text: '',
                type: 'error',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2000
              });
            }

          })

        }

      }
      else {
        Swal.fire({
          title: result.message,
          text: '',
          type: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000
        })
      }

    })
  }



}

